var Location = process.env.NODE_ENV === 'development' ? 'http://47.107.170.153' : '';
var config = {
  VUE_APP_API: Location + ':56072/api/',
  VUE_APP_USERAPI: Location + ':56074/api'
};
export default config;